<template>
  <div class="home">
    <Index />
    <div class="nav" ref="nav" :class="{'pin':fixed}">
      <div class="item" :class="{'active': active == 0}" @click="jump('#yindao')">引导</div>
      <div class="item" :class="{'active': active == 1}" @click="jump('#linian')">理念</div>
      <div class="item" :class="{'active': active == 2}" @click="jump('#sheji')">设计</div>
      <div class="item" :class="{'active': active == 3}" @click="jump('#shipin')">视频</div>
      <div class="item" :class="{'active': active == 4}" @click="jump('#cehua')">全案策划</div>
      <div class="item" :class="{'active': active == 5}" @click="jump('#hudong')">线上互动</div>
    </div>
    <div id="yindao" ref="yindao" class="nav_tag first"></div>
    <YinDao />
    <div id="linian" ref="linian" class="nav_tag"></div>
    <LiNian />
    <div id="sheji" ref="sheji" class="nav_tag"></div>
    <SheJi />
    <div id="shipin" ref="shipin" class="nav_tag"></div>
    <ShiPin />
    <div id="cehua" ref="cehua" class="nav_tag"></div>
    <CeHua />
    <div id="hudong" ref="hudong" class="nav_tag"></div>
    <HuDong />
  </div>
</template>

<script>
// @ is an alias to /src
const Index = () => import("@/components/Index");
const YinDao = () => import("@/components/YinDao");
const LiNian = () => import("@/components/LiNian");
const SheJi = () => import("@/components/SheJi");
const ShiPin = () => import("@/components/ShiPin");
const CeHua = () => import("@/components/CeHua");
const HuDong = () => import("@/components/HuDong");

export default {
  name: "Home",
  components: {
    Index,
    YinDao,
    LiNian,
    SheJi,
    ShiPin,
    CeHua,
    HuDong,
  },
  data() {
    return {
      fixed: false,
      active: 0,
      i:0
    };
  },
  methods: {
    jump(id) {
      document.querySelector(id).scrollIntoView(true);
    },
    topTab() {
      let i = this.$refs["yindao"].offsetTop;
      let linian = this.$refs["linian"].offsetTop;
      let sheji = this.$refs["sheji"].offsetTop;
      let shipin = this.$refs["shipin"].offsetTop;
      let cehua = this.$refs["cehua"].offsetTop;
      let hudong = this.$refs["hudong"].offsetTop;

      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; // 获取滚动值
      if (scrollTop >= i) {
        this.fixed = true;
      } else {
        this.fixed = false;
      }
      if (scrollTop < linian) {
        this.active = 0;
      } else if (scrollTop < sheji) {
        this.active = 1;
      } else if (scrollTop < shipin) {
        this.active = 2;
      } else if (scrollTop < cehua) {
        this.active = 3;
      } else if (scrollTop < hudong) {
        this.active = 4;
      } else {
        this.active = 5;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("scroll", this.topTab);
    });
  },
};
</script>

<style scoped lang="less">
.home {
  font-size: 0;
  position: relative;
  scroll-behavior: smooth;
}

.nav {
  display: flex;
  justify-content: space-around;
  font-weight: 600;
  align-items: center;
  font-size: 0.2rem;
  margin-top: -0.27rem;
  //margin-bottom: -0.27rem;
  position: sticky;
  color: #3a3a3a;
  top: 0;
  z-index: 10;

  .item {
    padding: 0.2rem;
    background-color: #fff;
    box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.8);
  }

  .active {
    font-size: 0.3rem;
    font-weight: bolder;
    padding: 0.4rem 0.3rem;
    color: #fff;
    transition: all 0.3s ease;


    &:nth-child(1) {
      background-color: #f6c783;
    }

    &:nth-child(2) {
      background-color: #ca7467;
    }

    &:nth-child(3) {
      background-color: #abbcbe;
    }

    &:nth-child(4) {
      background-color: #af7c89;
    }

    &:nth-child(5) {
      background-color: #b16484;
    }

    &:nth-child(6) {
      background-color: #7493af;
    }
  }
}

.pin {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
}

.nav_tag {
  margin-top: -1.2rem;
  height: 1.2rem;

  &.first {
    margin-top: -1.47rem !important;
  }
}
</style>
